
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire09bf"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire09bf"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $7nhm9 = parcelRequire("7nhm9");
const $74877f3caf25f50b$export$58c8b2136f4651dd = (selectedPlayers, teamsCount)=>{
    if (selectedPlayers.length < teamsCount) throw new Error("Not enough players to form the desired number of teams");
    const goalkeepers = selectedPlayers.filter((player)=>!!player.goalkeeper);
    const fieldPlayers = selectedPlayers.filter((player)=>!player.goalkeeper);
    const dividedGoalkeepers = $74877f3caf25f50b$var$getDividedPlayersByCoefficient(goalkeepers);
    const dividedFieldPlayers = $74877f3caf25f50b$var$getDividedPlayersByCoefficient(fieldPlayers);
    const concatenatedPlayers = [
        ...dividedFieldPlayers,
        ...dividedGoalkeepers
    ];
    const teams = Array.from({
        length: teamsCount
    }, ()=>[]);
    let lastIndex = 0;
    while(concatenatedPlayers.length){
        const playersByCategory = concatenatedPlayers.shift();
        while(playersByCategory.length){
            const candidate = playersByCategory.shift();
            if (!candidate) break;
            teams[lastIndex].push(candidate);
            lastIndex = (lastIndex + 1) % teamsCount; // Update lastIndex to cycle through the teams
        }
    }
    return teams;
};
const $74877f3caf25f50b$var$getDividedPlayersByCoefficient = (players)=>{
    const dividedPlayers = {};
    for (const player of players){
        if (!dividedPlayers[player.coefficient]) dividedPlayers[player.coefficient] = [];
        dividedPlayers[player.coefficient].push(player);
    }
    const concatedArray = [];
    for (const key of Object.keys(dividedPlayers).sort())concatedArray.push((0, $7nhm9.shuffleArray)(dividedPlayers[key]));
    return concatedArray;
};



var $7nhm9 = parcelRequire("7nhm9");

var $cuPh8 = parcelRequire("cuPh8");

var $8TdeO = parcelRequire("8TdeO");
const $151c3f6725f5ac58$var$generateTeamsBtn = document.getElementById("generateTeamsBtn");
const $151c3f6725f5ac58$var$randomizeBtn = document.getElementById("randomizeBtn");
const $151c3f6725f5ac58$var$teamResultContainerDiv = document.getElementById("teamResultContainerDiv");
const $151c3f6725f5ac58$var$teamResultTitle = document.getElementById("teamResultTitle");
const $151c3f6725f5ac58$var$amountOfTeamsInput = document.getElementById("amountOfTeamsInput");
$151c3f6725f5ac58$var$generateTeamsBtn.addEventListener("click", ()=>{
    $151c3f6725f5ac58$var$runGenerator();
    if ($151c3f6725f5ac58$var$teamResultTitle.classList.contains("d-none")) $151c3f6725f5ac58$var$teamResultTitle.classList.remove("d-none");
});
$151c3f6725f5ac58$var$randomizeBtn.addEventListener("click", ()=>$151c3f6725f5ac58$var$runGenerator());
const $151c3f6725f5ac58$var$runGenerator = ()=>{
    try {
        const players = (0, $cuPh8.getPlayers)();
        const teams = (0, $74877f3caf25f50b$export$58c8b2136f4651dd)((0, $7nhm9.getSelectedPlayers)(players), +$151c3f6725f5ac58$var$amountOfTeamsInput.value);
        (0, $8TdeO.appendTeamsResult)(teams);
        $151c3f6725f5ac58$var$teamResultContainerDiv.scrollIntoView({
            behavior: "smooth"
        });
    } catch (error) {
        alert(error.message);
    }
};


//# sourceMappingURL=index.23ba97f0.js.map
